export const IncomeTypeIds = {
    PRESCHOOL_FEE_ID: '3915acb0-db44-a323-c086-fe3376d2bfd4',
    DONATION_ID: 'af94450e-c92b-6e8a-88f0-b5ee19e6ff6f',
    DBE_SUBSIDY_ID: 'b58942b9-5199-5cdc-f103-7cbd048586af',
    OTHER_INCOME_ID: '8e8e9114-2c1d-d8e4-caf8-ed5ab9e1e78a',
};
//# sourceMappingURL=statements-income-types.dto.js.map